export default "__VITE_ASSET__Dgo9DBA$__"